module.exports = __webpack_public_path__ + "static/media/template1.681530f9.svg";